import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when Cookies Regulatory Message is being closed.
 * @memberOf Playtech.API.events
 * @event cookie-message-closed
 * @type {callback}
 * @example Playtech.on('cookie-message-closed', () => { ... });
 */
export const EVENT_COOKIE_MESSAGE_CLOSED = 'cookie-message-closed';

export const useOnCookieMessageClosed = (eventTarget) => {
    const handleEvent = useCallback(() => {
        const event = new CustomEvent(EVENT_COOKIE_MESSAGE_CLOSED);

        eventTarget.dispatchEvent(event);
    }, [
        eventTarget
    ]);

    useEffect(() => {
        publicEventsAPIService.on('cookieMessageClosed', handleEvent);

        return () => publicEventsAPIService.off('cookieMessageClosed', handleEvent);
    }, [
        handleEvent
    ]);
};
